// Stable Diffusion WebUI API Service
const API_BASE_URL = process.env.REACT_APP_SD_API_URL || 'http://172.16.9.9:7860';

export const sdApi = {
  // 文生图 (Text to Image)
  async txt2img(params) {
    const defaultParams = {
      prompt: '',
      negative_prompt: '',
      steps: 20,
      sampler_name: 'Euler a',
      cfg_scale: 7,
      width: 512,
      height: 512,
      batch_size: 1,
      n_iter: 1,
      seed: -1,
    };

    const response = await fetch(`${API_BASE_URL}/sdapi/v1/txt2img`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...defaultParams, ...params }),
    });

    if (!response.ok) throw new Error(`API Error: ${response.status}`);
    return response.json();
  },

  // 图生图 (Image to Image)
  async img2img(params) {
    const defaultParams = {
      prompt: '',
      negative_prompt: '',
      init_images: [],
      steps: 20,
      sampler_name: 'Euler a',
      cfg_scale: 7,
      width: 512,
      height: 512,
      denoising_strength: 0.75,
      batch_size: 1,
      n_iter: 1,
      seed: -1,
    };

    const response = await fetch(`${API_BASE_URL}/sdapi/v1/img2img`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...defaultParams, ...params }),
    });

    if (!response.ok) throw new Error(`API Error: ${response.status}`);
    return response.json();
  },

  async getSamplers() {
    const response = await fetch(`${API_BASE_URL}/sdapi/v1/samplers`);
    if (!response.ok) throw new Error(`API Error: ${response.status}`);
    return response.json();
  },

  async getSchedulers() {
    const response = await fetch(`${API_BASE_URL}/sdapi/v1/schedulers`);
    if (!response.ok) throw new Error(`API Error: ${response.status}`);
    return response.json();
  },

  async getModels() {
    const response = await fetch(`${API_BASE_URL}/sdapi/v1/sd-models`);
    if (!response.ok) throw new Error(`API Error: ${response.status}`);
    return response.json();
  },

  async getLoras() {
    const response = await fetch(`${API_BASE_URL}/sdapi/v1/loras`);
    if (!response.ok) throw new Error(`API Error: ${response.status}`);
    return response.json();
  },

  async refreshLoras() {
    const response = await fetch(`${API_BASE_URL}/sdapi/v1/refresh-loras`, { method: 'POST' });
    if (!response.ok) throw new Error(`API Error: ${response.status}`);
    return response.json();
  },

  async getProgress() {
    const response = await fetch(`${API_BASE_URL}/sdapi/v1/progress`);
    if (!response.ok) throw new Error(`API Error: ${response.status}`);
    return response.json();
  },

  async interrupt() {
    const response = await fetch(`${API_BASE_URL}/sdapi/v1/interrupt`, { method: 'POST' });
    if (!response.ok) throw new Error(`API Error: ${response.status}`);
    return response.json();
  },

  async getOptions() {
    const response = await fetch(`${API_BASE_URL}/sdapi/v1/options`);
    if (!response.ok) throw new Error(`API Error: ${response.status}`);
    return response.json();
  },

  async setModel(modelName) {
    const response = await fetch(`${API_BASE_URL}/sdapi/v1/options`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sd_model_checkpoint: modelName }),
    });
    if (!response.ok) throw new Error(`API Error: ${response.status}`);
    return response.json();
  },
};

export default sdApi;

